import { useCallback } from 'react';
import { useAsset } from '@artica/assets';
import { useThree } from '@react-three/fiber';
import { parallax } from '@immutabl3/alchemy/three';
import clonerArm0Cloner0 from './cloner-arm-0.cloner-0.json';
import clonerArm0Cloner1 from './cloner-arm-0.cloner-1.json';
import clonerArm2Cloner4 from './cloner-arm-2.cloner-4.json';
import clonerArm2Cloner5 from './cloner-arm-2.cloner-5.json';
import clonerArm3Cloner6 from './cloner-arm-3.cloner-6.json';
import clonerArm3Cloner7 from './cloner-arm-3.cloner-7.json';
import generateMeshPreset from '../common/generateMeshPreset';

export default function ClonerArms() {
  const {
    nodes,
    materials,
    perfectSphereGeometry,
  } = useAsset('dyson');

  const camera = useThree(({ camera }) => camera);
  const onPercChange = useCallback((_, ref) => {
    if (!camera) return;

    const children = ref?.current?.children;
    if (!children) return;

    for (const mesh of children) {
      if (mesh.geometry !== perfectSphereGeometry) continue;
      mesh.lookAt(camera.position);
    }
  }, [camera]);

  return (
    <group
      name="radial_cloner_ARMS"
      position={[-0.3378, 15.7038, -1.8892] }
      rotation={[1.45107, 0.021356, 0.168379] }
      scale={1.207 }
    >
      <group
        name="Cloner_Arm_0"
        position={ [0, 7, 0] }
        rotation={ [0, 0, -1.45] }
        scale={ 0.61 }
      >
        <group
          name="Cloner"
          position={ [273.32, -553.89, -160.59] }
          rotation={ [-0.34, -0.23, -1.64] }
        >
          { clonerArm0Cloner0.map(generateMeshPreset({
            nodes,
            materials,
            geometry: 'armAClones_0',
          })) }
        </group>
        <group
          name="Cloner_1"
          position={ [273.32, -553.89, -160.59] }
          rotation={ [-0.34, -0.23, -1.64] }
        >
          { clonerArm0Cloner1.map(generateMeshPreset({
            nodes,
            materials,
            geometry: 'armAClones_0',
          })) }
        </group>
      </group>
      <group
        name="Cloner_Arm_2"
        position={ [4.11, -5.66, 0] }
        rotation={ [0, 0, 2.32] }
        scale={ 0.61 }
      >
        <group
          name="Cloner_4"
          position={ [273.32, -553.89, -160.59] }
          rotation={ [-0.34, -0.23, -1.64] }
        >
          { clonerArm2Cloner4.map(generateMeshPreset({
            nodes,
            materials,
            geometry: 'armAClones_0',
          })) }
        </group>
        <group
          name="Cloner_5"
          position={ [273.32, -553.89, -160.59] }
          rotation={ [-0.34, -0.23, -1.64] }
        >
          { clonerArm2Cloner5.map(generateMeshPreset({
            nodes,
            materials,
            geometry: 'armAClones_0',
          })) }
        </group>
      </group>
      <group
        name="Cloner_Arm_3"
        position={[-4.1145, -5.6631, 0] }
        rotation={[0, 0, 1.064651] }
        scale={0.614 }
      >
        <parallax.group
          name="Cloner_6"
          position={[273.3166, -553.8941, -160.5868] }
          rotation={[-0.343133, -0.234625, -1.638093] }

          beaker="chapter2"
          onPercChange={ onPercChange }
        >
          { clonerArm3Cloner6.map(generateMeshPreset({
            nodes,
            materials,
            geometry: perfectSphereGeometry,
          })) }
        </parallax.group>
        <parallax.group
          name="Cloner_7"
          position={[273.3166, -553.8941, -160.5868] }
          rotation={[-0.343133, -0.234625, -1.638093] }

          beaker="chapter2"
          onPercChange={ onPercChange }
        >
          { clonerArm3Cloner7.map(generateMeshPreset({
            nodes,
            materials,
            geometry: perfectSphereGeometry,
          })) }
        </parallax.group>
      </group>
    </group>
  );
};